<template>
  <div class="ProductItem tw-mb-4 md:tw-mb-0">
    <div class="tw-aspect-w-1 tw-aspect-h-1">
      <img :src="imageSrcOrigin + item.ImageSrc" :alt="item.ImageAlt" />
    </div>
    <div
      class="
        tw-border-1 tw-border-gray-200 tw-border-solid tw-border-t-0 tw-p-3
      "
    >
      <a
        class="tw-text-sm tw-font-bold tw-text-noraLightBlue-200 productName"
        @click="trackDetailsEvent('productClick')"
        :href="item.ProductPageUrl"
        target="_blank"
        v-html="item.ProductName"
      ></a>
      <p class="tw-text-sm">
        <strong>{{ item.ColorName }}</strong>
      </p>
      <div class="tw-flex tw-mt-2 tw--mx-0.5 iconContainer">
        <template v-for="(icon, index) in item.Icons" :key="index">
          <img
            class="tw-px-0.5 tw-h-5"
            :src="icon.Url"
            :title="icon.TitleText"
          />
        </template>
      </div>
      <span
        v-if="state == 'products'"
        class="
          tw-flex tw-mt-2 tw-text-sm tw-underline
          hover:tw-no-underline
          tw-cursor-pointer tw-items-center
        "
        @click="toggleDetails"
        >{{ ProductDetailTexts.DetailAccordionButton }}
        <ChevronDownIcon
          :class="detailsOpen ? 'tw-transform tw-rotate-180' : ''"
          class="tw-h-4 tw-w-4"
          aria-hidden="true"
      /></span>
    </div>
    <div
      v-show="detailsOpen && state == 'products'"
      class="
        Details
        tw-border-solid
        tw-border-1
        tw-border-gray-200
        tw-mt-5
        tw-px-3
        tw-py-5
        tw-flex
      "
      :class="detailsOpen ? 'tw-relative tw-z-10' : ''"
    >
      <div
        class="
          tw-w-full
          lg:tw-grid
          md:tw-grid-cols-5
          lg:tw-grid-cols-5
          md:tw-gap-2
        "
      >
        <div class="col-span-full lg:tw-col-span-2">
          <section v-html="item.KeyFeatures" class="tw-prose"></section>
          <div class="tw-mt-5">
            <!--            <h3 class="tw-mb-2">{{ ProductDetailTexts.KeyFeatureHeadline }}</h3>-->
            <!--            <p>-->
            <!--              <strong>{{ ProductDetailTexts.CollectionLabel }}</strong>-->
            <!--              {{ Collection }}-->
            <!--            </p>-->
            <!--            <p>-->
            <!--              <strong>{{ ProductDetailTexts.FormatLabel }}</strong>-->
            <!--              {{ Format }}-->
            <!--            </p>-->
            <!--            <p>-->
            <!--              <strong>{{ ProductDetailTexts.FloorThicknessLabel }}</strong>-->
            <!--              {{ FloorThickness }}-->
            <!--            </p>-->
          </div>
        </div>
        <div class="relatedProducts col-span-full lg:tw-col-span-3">
          <Slider
            :images="item.Gallery"
            v-if="item.Gallery && item.Gallery.length > 0"
          />

          <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-my-2">
            <a
              v-if="item.ProductPageUrl"
              :href="item.ProductPageUrl"
              @click="trackDetailsEvent('productPage')"
              target="_blank"
              class="
                tw-flex tw-items-center tw-justify-center tw-bg-noraBlue-400
                hover:tw-bg-noraBlue-500
                tw-text-white
                tw-font-bold
                tw-py-2
                tw-px-4
                tw-rounded
                tw-text-center
                tw-w-full
                tw-col-start-1
              "
              >{{ ProductDetailTexts.ProductPageLinkText }}</a
            >
            <a
              v-if="quickShipFilterSelected && item.QuickShipUrl"
              :href="item.QuickShipUrl"
              target="_blank"
              class="
                tw-flex tw-items-center tw-justify-center tw-bg-noraBlue-400
                hover:tw-bg-noraBlue-500
                tw-text-white
                tw-font-bold
                tw-text-m
                tw-py-2
                tw-px-4
                tw-rounded
                tw-text-center
                tw-w-full
                tw-col-start-1
              "
              >{{ ProductDetailTexts.QuickShipLinkText }}</a
            >
            <a
              v-if="item.DesignRoomUrl"
              :href="item.DesignRoomUrl"
              @click="trackDetailsEvent('roomDesigner')"
              target="_blank"
              class="
                tw-flex tw-items-center tw-justify-center tw-bg-noraBlue-400
                hover:tw-bg-noraBlue-500
                tw-text-white
                tw-font-bold
                tw-text-m
                tw-py-2
                tw-px-4
                tw-rounded
                tw-text-center
                tw-w-full
                tw-col-start-1
              "
              >{{ ProductDetailTexts.DesignRoomLinkText }}</a
            >
            <a
              v-if="
                item.ItemGuid &&
                !item.DisableOrderRequest &&
                !addedInOrder &&
                AddToOrderUrl
              "
              href="#"
              @click.prevent="addItemToOrder()"
              class="
                tw-flex tw-items-center tw-justify-center tw-bg-noraBlue-400
                hover:tw-bg-noraBlue-500
                tw-text-white
                tw-font-bold
                tw-text-m
                tw-py-2
                tw-px-4
                tw-rounded
                tw-text-center
                tw-w-full
                tw-col-start-2
                tw-row-start-1
              "
            >
              {{ ProductDetailTexts.AddToOrderLinkText }}
            </a>
            <a
              v-if="
                item.ItemGuid &&
                !item.DisableOrderRequest &&
                addedInOrder &&
                RemoveFromOrderUrl
              "
              href="#"
              @click.prevent="removeItemFromOrder()"
              class="
                tw-flex tw-items-center tw-justify-center tw-bg-noraBlue-400
                hover:tw-bg-noraBlue-500
                tw-text-white
                tw-font-bold
                tw-text-m
                tw-py-2
                tw-px-4
                tw-rounded
                tw-text-center
                tw-w-full
                tw-col-start-2
                tw-row-start-1
              "
            >
              {{ ProductDetailTexts.RemoveFromOrderLinkText }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <template v-if="modalVisible && !item.DisableOrderRequest">
      <Modal
        :title="ProductDetailTexts.OrderModalTitle"
        @close="modalVisible = false"
      >
        <div class="tw-flex tw-gap-8">
          <img
            :src="imageSrcOrigin + item.ImageSrc"
            :alt="item.ImageAlt"
            width="288"
            height="288"
            class="tw-w-72 tw-h-72"
          />
          <div>
            <h3
              class="tw-font-bold tw-text-noraLightBlue-200 productName"
              v-html="item.ProductName"
            ></h3>
            <p class="tw-text-sm">
              {{ item.ColorName }}
            </p>
            <div class="tw-flex tw-mt-2 tw--mx-0.5 iconContainer">
              <template v-for="(icon, index) in item.Icons" :key="index">
                <img
                  class="tw-px-0.5 tw-h-5"
                  :src="icon.Url"
                  :title="icon.TitleText"
                />
              </template>
            </div>
          </div>
        </div>

        <hr />

        <div class="tw-flex tw-justify-between tw-p-4">
          <button
            class="
              tw-bg-noraBlue-400
              hover:tw-bg-noraBlue-500
              tw-text-white
              tw-font-bold
              tw-py-2
              tw-px-4
              tw-rounded
              tw-text-center
              tw-w-60
              tw-col-start-1
            "
            @click.prevent="modalVisible = false"
          >
            {{ ProductDetailTexts.OrderModalBackButton }}
          </button>
          <a
            :href="OrderPageUrl"
            class="
              tw-bg-noraBlue-400
              hover:tw-bg-noraBlue-500
              tw-text-white
              tw-font-bold
              tw-py-2
              tw-px-4
              tw-rounded
              tw-text-center
              tw-w-60
              tw-col-start-1
            "
          >
            {{ ProductDetailTexts.OrderModalSampleButton }}
          </a>
        </div>
      </Modal>
    </template>
  </div>
</template>

<script>
import Slider from "../Slider";
import Modal from "../Modal";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import { addToOrder, removeFromOrder } from "@/services/order-service";

export default {
  name: "ProductItem",
  props: {
    item: Object,
    index: Number,
    openIndex: String,
    ProductDetailTexts: Object,
    state: String,
    filters: Object,
  },
  data() {
    return {
      addedInOrder: this.item.AddedInOrder,
      modalVisible: false,
    };
  },
  computed: {
    detailsOpen() {
      return this.index.toString() === this.openIndex;
    },
    relatedProducts() {
      if (this.item.Products) {
        const products = this.item.Products.filter(
          (product) =>
            product.IsDefault ||
            product.IsEc ||
            product.IsEd ||
            product.IsNtx ||
            product.IsAcoustic
        );
        return this.getProductsUniqBy("ProductPageName", products);
      }
      return 0;
    },
    quickShipFilterSelected() {
      const quickShipFilterGroup = this.filters.find(
        (filter) => filter.Group === "IsQuickShip"
      );

      if (!quickShipFilterGroup) {
        return false;
      }

      return quickShipFilterGroup.Items[0].Selected;
    },
  },
  methods: {
    toggleDetails() {
      this.$emit("toggleDetails", this.index);

      if (!this.detailsOpen) {
        this.trackDetailsEvent("productDetail");
      }
    },
    async addItemToOrder() {
      const result = await addToOrder(this.item.ItemGuid);

      if (result.success) {
        this.modalVisible = true;
        this.addedInOrder = true;

        this.trackDetailsEvent("sampleOrder");
      }
    },
    async removeItemFromOrder() {
      const result = await removeFromOrder(this.item.ItemGuid);

      if (result.success) {
        this.addedInOrder = false;
      }
    },
    getProductsUniqBy(key, products) {
      return [...new Map(products.map((item) => [item[key], item])).values()];
    },
    trackDetailsEvent(eventName) {
      const eventData = {
        event: eventName,
        eventTimeout: 2000,
        eventCallback: () => {
          console.log("Tracking event successfull: executing callback");
        },
        filterUse: "Filter Bodenbelagsuche",
        product: this.item.ProductNameText,
        productNumber: this.item.ItemGuid,
        color: this.getSelectedFilterValues("ColorGroupName"),
        surface: this.getSelectedFilterValues("Texture"),
        inlays: this.getSelectedFilterValues("Inlay"),
        soundLevel: this.getSelectedFilterValues("SoundInsulation"),
        moistureLimits: this.getSelectedFilterValues("US_MoistureLimit"),
        rollingLoads: this.getSelectedFilterValues("US_RollingLoad"),
        antiSlip: this.getSelectedFilterValues("SlipResistance"),
        esd: this.getSelectedFilterValues("EsdProperties"),
        fireClassification: this.getSelectedFilterValues("FireBehaviour"),
        otherFeatures: this.getSelectedFilterValues("FurtherProperties"),
        format: this.getSelectedFilterValues("Format"),
        thickness: this.getSelectedFilterValues("FloorThickness"),
        technique: this.getSelectedFilterValues("InstallationMethod"),
        ecoLabels: this.getSelectedFilterValues("Certificates"),
        quickShip: this.getSelectedFilterValues("IsQuickShip"),
      };

      this.pushTrackingEvent(eventData);
    },
    pushTrackingEvent(eventData) {
      if (window.dataLayer && this.isGTMInitialized()) {
        console.log("Tracking event triggered: ", eventData);

        window.dataLayer.push(eventData);
      } else {
        console.warn(
          "Ignore tracking event: GTM is not initialized",
          eventData
        );
      }
    },
    getSelectedFilterValues(groupName) {
      const group = this.filters.find((filter) => filter.Group === groupName);

      if (!group || !group.Items) {
        return null;
      }

      let selectedItems = group.Items.filter((item) => item.Selected);

      if (selectedItems.length < 1) {
        return null;
      }

      if (!selectedItems[0].Value) {
        // return null when "any is selected"
        return null;
      }

      return this.getItemTexts(selectedItems).join(",");
    },
    getItemTexts(items) {
      return items.map((item) => item.Text);
    },
    isGTMInitialized() {
      var gtmStartEvent = window.dataLayer.find(function (element) {
        return element["gtm.start"];
      });

      return gtmStartEvent && gtmStartEvent["gtm.uniqueEventId"];
    },
  },
  components: {
    ChevronDownIcon,
    Slider,
    Modal,
  },
};
</script>

<style scoped>
/*First and Every fifth */
@screen sm {
  .ProductItem .Details {
    margin-left: 0;
    margin-right: calc(-100% - 1.25em);
  }
  .ProductItem:nth-child(2n) .Details {
    margin-left: calc(-100% - 1.25em);
    margin-right: 0;
  }
}
@screen xl {
  /*Every third item*/
  .ProductItem:nth-child(4n - 1) .Details {
    margin-left: calc(-200% - 2.5em);
    margin-right: calc(-100% - 1.25em);
  }
  /*Every second item*/
  .ProductItem:nth-child(4n - 2) .Details {
    margin-left: calc(-100% - 1.25em);
    margin-right: calc(-200% - 2.5em);
  }

  /*Every fourth item*/
  .ProductItem:nth-child(4n - 4) .Details {
    margin-left: calc(-300% - 3.75em);
  }

  /*Every fifth item*/
  .ProductItem:nth-child(4n + 1) .Details {
    margin-right: calc(-300% - 3.75em);
  }
}

.iconContainer {
  min-height: 20px;
}

.productName {
  display: block;
  display: -webkit-box;
  /* line height * 2 */
  height: 40px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
